import {NgModule, Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
	selector: 'copy-row',
	templateUrl: 'copy-row.template.html',
    styleUrls: ['copy-row.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CopyRow {
    @Input() item: any;
    @Input() pre:boolean;

    ngOnInit(){
        
    }

    ngAfterViewInit(){
        
    }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/copy-row/copy-row.component.ts